import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { QRInputAutocomplete } from 'src/app/models/qr-input-autocomplete.model';
import { QRInput } from 'src/app/models/qr-input.model';
import { PanelService } from 'src/app/services/panel.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserSessionService } from 'src/app/services/user-session.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class PanelHomeComponent implements OnInit {
  userDisplayName: string = '-';
  user: any = [];
  userId = 0;
  isLoading: boolean = true;
  loggedUserSubscription: Subscription | undefined;
  offices: { agency: string; id: number }[] = [];

  //--------------------Autocomplete--------------------
  inputAutocompleteString: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Cambiar oficina',
    isCleanButtonVisible: true,
    options: [],
  };

  constructor(
    private readonly userSessionService: UserSessionService,
    private readonly panelService: PanelService,
    public snackbarService: SnackbarService
  ) {}

  // ------------------------------OnInit------------------------------
  ngOnInit(): void {
    this.getUserData();

    this.loadOfficesDropdown();
  }

  // ------------------------------FUNCTIONS------------------------------

  getUserData() {
    this.loggedUserSubscription = this.userSessionService.loggedUser$.subscribe(
      (loggedUser: any) => {
        if (loggedUser != null) {
          this.user = loggedUser;
          this.userId = loggedUser.id;
          this.userDisplayName = loggedUser.name;
          this.isLoading = false;
        }
      }
    );
  }
  loadOfficesDropdown() {
    this.panelService.getPanelOffices().then(
      (response: any) => {
        if (response?.data) {
          this.offices = response.data;
          for (const ITEM of this.offices) {
            this.inputAutocompleteString.options.push(ITEM.agency);
          }
        }
      },
      (error: Error) => {
        console.log(error);
      }
    );
  }

  officeSelected(event: any) {
    let officeWithId = this.offices.filter((e: any) => e.agency === event);
    if (officeWithId) {
      this.panelService.postPanelOffices(officeWithId[0].id, this.userId).then(
        (response: any) => {
          this.snackbarService.openWithVariableDuration(
            'Cambio a oficina ' +
              event +
              ' exitoso. Por favor cierre sesion y vuelva a ingresar.',
            '',
            5 * 1000
          );
        },
        (error: Error) => {
          console.log(error);
        }
      );
    }
  }
}
